import { NotificationEventKey, NotificationProductCode } from '@gb-ticket/shared-types';

export type ProfileNotificationTableSection = {
  title: string;
  eventKeys: readonly NotificationEventKey[];
};

/** Subheadings within each product table (Profile-design §5.3). */
export const PROFILE_NOTIFICATION_TABLE_SECTIONS: Partial<
  Record<NotificationProductCode, ProfileNotificationTableSection[]>
> = {
  [NotificationProductCode.HELPDESK]: [
    {
      title: 'Meine Tickets',
      eventKeys: [
        NotificationEventKey.CREATED,
        NotificationEventKey.STATUS_CHANGED,
        NotificationEventKey.COMMENTED,
        NotificationEventKey.ASSIGNED,
        NotificationEventKey.UPDATED,
        NotificationEventKey.RESOLVED_REMINDER,
        NotificationEventKey.CSAT,
      ],
    },
    {
      title: 'Freigaben und Fristen',
      eventKeys: [
        NotificationEventKey.SLA_WARNING,
        NotificationEventKey.APPROVAL_REQUESTED,
        NotificationEventKey.APPROVAL_DECIDED,
      ],
    },
    {
      title: 'Betrieb',
      eventKeys: [
        NotificationEventKey.INCIDENT_BROADCAST,
        NotificationEventKey.AUTOMATION,
        NotificationEventKey.REMOTE_SESSION,
      ],
    },
  ],
  [NotificationProductCode.INTRANET]: [
    {
      title: 'Nachrichten und Pflicht',
      eventKeys: [
        NotificationEventKey.INTRANET_NEWS_PUBLISHED,
        NotificationEventKey.INTRANET_ACK_REQUIRED,
        NotificationEventKey.INTRANET_ACK_REMINDER,
      ],
    },
    {
      title: 'Reaktionen',
      eventKeys: [
        NotificationEventKey.INTRANET_CONTENT_LIKED,
        NotificationEventKey.INTRANET_COMMENT_CREATED,
        NotificationEventKey.INTRANET_COMMENT_REPLIED,
        NotificationEventKey.INTRANET_COMMENT_LIKED,
        NotificationEventKey.INTRANET_MENTIONED,
      ],
    },
    {
      title: 'Redaktion',
      eventKeys: [
        NotificationEventKey.INTRANET_REVIEW_DUE,
        NotificationEventKey.INTRANET_SITE_DIARY_SUBMITTED,
      ],
    },
  ],
  [NotificationProductCode.LEAVE]: [
    {
      title: 'Anträge',
      eventKeys: [
        NotificationEventKey.LEAVE_REQUEST_SUBMITTED,
        NotificationEventKey.LEAVE_REQUEST_APPROVED,
        NotificationEventKey.LEAVE_REQUEST_REJECTED,
        NotificationEventKey.LEAVE_REQUEST_CANCELLED,
      ],
    },
    {
      title: 'Hinweise',
      eventKeys: [
        NotificationEventKey.LEAVE_REMINDER_UPCOMING,
        NotificationEventKey.LEAVE_SICK_REPORTED,
      ],
    },
  ],
  [NotificationProductCode.FLEET]: [
    {
      title: 'Fahrzeuge',
      eventKeys: [
        NotificationEventKey.FLEET_ASSIGNMENT_STARTED,
        NotificationEventKey.FLEET_DAMAGE_REPORTED,
        NotificationEventKey.FLEET_DAMAGE_CLOSED,
      ],
    },
    {
      title: 'Fristen',
      eventKeys: [
        NotificationEventKey.FLEET_REMINDER_UPCOMING,
        NotificationEventKey.FLEET_REMINDER_OVERDUE,
      ],
    },
  ],
  [NotificationProductCode.ONBOARDING]: [
    {
      title: 'Aufgaben',
      eventKeys: [
        NotificationEventKey.ONBOARDING_TASK_ASSIGNED,
        NotificationEventKey.ONBOARDING_TASK_DUE_SOON,
        NotificationEventKey.ONBOARDING_TASK_OVERDUE,
      ],
    },
    {
      title: 'Vorgänge',
      eventKeys: [
        NotificationEventKey.ONBOARDING_CASE_STARTED,
        NotificationEventKey.ONBOARDING_SUBJECT_ADMITTED,
        NotificationEventKey.ONBOARDING_CASE_COMPLETED,
      ],
    },
  ],
};
